import React from 'react';
import {
  string,
  func,
  arrayOf,
  shape,
  bool,
  oneOf,
} from 'prop-types';

import FormInputContainer from '../../../scaffolding/FormInputContainer/FormInputContainer';
import SelectV2 from '../../../controls/SelectV2/SelectV2';

const SelectWithLabel = (
  {
    id,
    required,
    label,
    value,
    onChange,
    options,
    errorMsg,
  },
) => (
  <FormInputContainer>
    <label htmlFor={id}>{label}</label>

    <SelectV2
      id={id}
      errorMsg={errorMsg}
      required={required}
      value={value}
      options={options}
      onChange={(e) => { if (onChange) onChange(e); }}
    />
    <div role="alert" aria-live="assertive" id={`${id}_error`}>
      {errorMsg?.length > 0 && <div className="errorText">{errorMsg}</div>}
    </div>
  </FormInputContainer>
);

SelectWithLabel.propTypes = {
  id: string.isRequired,
  required: bool,
  label: string.isRequired,
  value: string,
  onChange: func,
  options: arrayOf(shape({
    disabled: bool,
    display: string.isRequired,
    value: string,
  })).isRequired,
  errorMsg: string,
  version: oneOf([1, 2]),
};

SelectWithLabel.defaultProps = {
  onChange: null,
  errorMsg: null,
  required: true,
  value: '',
  version: 1,
};

export default SelectWithLabel;
